import { styled } from "@styles";

export const ShadowBox = styled.div`
  bottom: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  filter: blur(6px);
  height: 94%;
  left: 3%;
  position: absolute;
  width: 94%;
  z-index: -1;
`;
